import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import bgGradient from '@/assets/images/bg-gradient.webp';
import logoSvg from '@/assets/images/logo-black.svg';
import { useBoundStore } from '@/store/store';

export const Route = createFileRoute('/_authLayout')({
  component: AuthLayout,
  beforeLoad: async () => {
    if (useBoundStore.getState().jwt) {
      throw redirect({
        to: '/inbox',
      });
    }
  },
});

export function AuthLayout() {
  return (
    <div className='flex h-screen flex-col bg-background 2xl:flex-row'>
      <div className='absolute z-10 block size-full 2xl:relative 2xl:w-1/2'>
        <div className='relative flex h-screen items-center justify-center 2xl:justify-end'>
          <img src={bgGradient} className='size-full object-cover' />
        </div>
      </div>
      <div className='relative z-20 flex size-full w-full items-center justify-center px-12 2xl:w-1/2 2xl:justify-start 2xl:bg-slate-100 2xl:pl-44'>
        <div className='relative flex w-full max-w-[520px] flex-col items-center rounded-lg bg-white p-16 shadow-lg'>
          <div className='mb-12 h-12'>
            <img src={logoSvg} alt='ff-logo' className='size-full' />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
